type RefreshControl = {
  checked?: boolean;
  defaultChecked?: boolean;
  defaultValue?: string;
  disabled?: boolean;
  files?: { length: number } | null;
  options?: ArrayLike<{ defaultSelected: boolean; selected: boolean }>;
  tagName?: string;
  type?: string;
  value?: string;
};

type RefreshForm = {
  dataset?: { releaseRefreshSafe?: string };
  elements: ArrayLike<RefreshControl>;
  method?: string;
};

const ignoredInputTypes = new Set(["button", "hidden", "image", "reset", "submit"]);

export function isReleaseComparable(release: string) {
  return Boolean(release) && release !== "development" && release !== "unversioned";
}

export function didReleaseChange(loadedRelease: string, currentRelease: string) {
  return isReleaseComparable(loadedRelease)
    && isReleaseComparable(currentRelease)
    && loadedRelease !== currentRelease;
}

export function hasDirtyRefreshForm(forms: ArrayLike<RefreshForm>) {
  return Array.from(forms).some((form) => {
    if (form.dataset?.releaseRefreshSafe === "true") return false;
    if (form.method?.toLowerCase() === "get") return false;
    return Array.from(form.elements).some(isDirtyRefreshControl);
  });
}

export function isDirtyRefreshControl(control: RefreshControl) {
  if (control.disabled) return false;
  const tagName = control.tagName?.toLowerCase();
  const type = control.type?.toLowerCase() ?? "";

  if (tagName === "input" && ignoredInputTypes.has(type)) return false;
  if (tagName === "input" && type === "file") return Boolean(control.files?.length);
  if (tagName === "input" && (type === "checkbox" || type === "radio")) {
    return control.checked !== control.defaultChecked;
  }
  if (tagName === "select") {
    return Array.from(control.options ?? []).some(
      (option) => option.selected !== option.defaultSelected,
    );
  }
  if (tagName === "input" || tagName === "textarea") {
    return (control.value ?? "") !== (control.defaultValue ?? "");
  }
  return false;
}
